/**
 * Utility para cargar dinámicamente las imágenes de artistas desde la estructura de carpetas
 * Estructura: fotos/Dia-Numero/NombreArtista/imagen.*
 */

// Cargar todas las imágenes de la carpeta fotos recursivamente
// El parámetro 'true' hace que sea recursivo
// La regex busca cualquier imagen (jpg, jpeg, png, JPG, etc.)
const images = require.context('./fotos', true, /\.(jpe?g|png|JPE?G|PNG)$/);

/**
 * Procesa las rutas de las imágenes y organiza por días y artistas
 * @returns {Array} Array de objetos con estructura: { dia: "Viernes 6", artistas: [...] }
 */
export function loadArtistasData() {
    const diasMap = {};

    // Iterar sobre todas las imágenes encontradas
    images.keys().forEach((imagePath) => {
        // Ejemplo de imagePath: "./Viernes-6/Soledad/index.JPG"
        const parts = imagePath.split('/');
        
        // Verificar que tenga la estructura correcta: ./DiaFolder/ArtistaFolder/imagen.ext
        if (parts.length >= 4) {
            const diaFolder = parts[1]; // "Viernes-6"
            const artistaFolder = parts[2]; // "Soledad"
            const imageName = parts[parts.length - 1]; // "index.JPG"
            
            // Parsear el nombre del día: "Viernes-6" -> "Viernes 6"
            const [diaNombre, diaNumero] = diaFolder.split('-');
            const diaDisplay = `${diaNombre} ${diaNumero}`;
            
            // Inicializar el día si no existe
            if (!diasMap[diaDisplay]) {
                diasMap[diaDisplay] = {
                    dia: diaDisplay,
                    diaKey: diaFolder,
                    artistas: {}
                };
            }
            
            // Inicializar el artista si no existe
            if (!diasMap[diaDisplay].artistas[artistaFolder]) {
                diasMap[diaDisplay].artistas[artistaFolder] = {
                    nombre: artistaFolder,
                    imagenes: []
                };
            }
            
            // Agregar la imagen al artista
            diasMap[diaDisplay].artistas[artistaFolder].imagenes.push({
                path: imagePath,
                url: images(imagePath),
                fileName: imageName
            });
        }
    });

    // Convertir el map a array y procesar
    const diasArray = Object.values(diasMap).map(dia => {
        // Convertir artistas de objeto a array
        const artistasArray = Object.values(dia.artistas).map(artista => {
            // Ordenar imágenes: priorizar "index.*" primero
            const imagenesOrdenadas = artista.imagenes.sort((a, b) => {
                const aIsIndex = a.fileName.toLowerCase().startsWith('index');
                const bIsIndex = b.fileName.toLowerCase().startsWith('index');
                
                if (aIsIndex && !bIsIndex) return -1;
                if (!aIsIndex && bIsIndex) return 1;
                return 0;
            });

            return {
                id: artista.nombre.replace(/\s+/g, '-').toLowerCase(),
                nombre: artista.nombre,
                // Imagen principal es la primera (index si existe, o la primera disponible)
                imagenPrincipal: imagenesOrdenadas[0]?.url || '',
                // Todas las imágenes disponibles
                imagenes: imagenesOrdenadas.map(img => img.url)
            };
        });

        return {
            dia: dia.dia,
            diaKey: dia.diaKey,
            artistas: artistasArray
        };
    });

    // Ordenar días: Viernes, Domingo, Lunes
    const ordenDias = { 'Viernes': 1, 'Sábado': 2, 'Domingo': 3, 'Lunes': 4 };
    
    diasArray.sort((a, b) => {
        const aNombre = a.dia.split(' ')[0];
        const bNombre = b.dia.split(' ')[0];
        
        return (ordenDias[aNombre] || 999) - (ordenDias[bNombre] || 999);
    });

    return diasArray;
}

// Exportar también los datos precargados para usar directamente
export const artistasData = loadArtistasData();

